<template lang='pug'>
//- 回報檢舉區塊
div(:class='$style[`cc-popbox-report`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 檢
        span.font-normal-theme 舉
        span.no-wrap 說明

    Inputer(
      title='填寫檢舉說明'
      v-model='formConfig.reportValue'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`說明..`'
      :errorValue='checkEmptyStatus.reportError'
      :keyPressEnter='handleCheckProgressBeforeLogin'
      @clearErrorMsg='(value) => {this.checkEmptyStatus.reportError = value[0];}')

    div(
      title="送出"
      :class='[$style[`cc-content-new-send`], $style[!this.formConfig.reportValue && !this.formConfig.reportValue ? `cc-content-disabled` : ``]]'
      @click='handleCheckProgressBeforeLogin')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `送出`}}


</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';

import {
  getCurrentDate,
  postCreateNewReport,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
  },

  props: {
    detail: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showLoading: false,

      formConfig: {
        reportValue: '',
      },
      checkEmptyStatus: {
        reportError: false,
      },
      verifyAllPass: true,
      // showErrorMsg: false,
    };
  },

  // created() {
  //   this.showErrorMsg = this.$options.data().showErrorMsg;
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopReportStatus: 'global/POPREPORT_STATUS',
    }),

    handleClosePopBox() {
      this.changePopReportStatus({
        active: false,
        detail: {},
      });
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = this.$options.data().verifyAllPass;

      if (!this.formConfig.reportValue) {
        // 內容為空
        this.formConfig.reportError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      if (!this.verifyAllPass) { return; }
      this.showLoading = true;

      getCurrentDate('')
        .then((res) => {
          const PASS_DATA = {
            auth_id: `${this.loginDjangoId}`,
            author_id: `${this.detail.author_id}`,
            content_id: `${this.detail.content_id}`,
            type: `${this.detail.type}`,
            describe: `${this.formConfig.reportValue}`,
            date: `${res.data}`,
          };

          postCreateNewReport('', PASS_DATA).then((res) => {
            this.showLoading = false;
            // this.handleUserAddHp(this.loginDjangoId, '+50');
            this.changePopReportStatus({
              active: false,
              detail: {},
            });

            this.changePopBoxStatus({
              active: true,
              include: 'sendConfirm',
            });

            setTimeout(() => {
              this.changePopBoxStatus({
                active: false,
                include: '',
              });
            }, this.POP_DURATION);
          }).catch((err) => {
            console.log('postCreateNewReport 失敗', err);
          });
        })
        .catch((err) => {
          console.log('getCurrentDate 失敗', err);
        });
    },

    async handleCheckProgressBeforeLogin() {
      await this.handleFormsCheckToPass();
      await this.handleConnectDjangoWithApi();
    },

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popUserReport.scss';
</style>
